import { FormatUnderlined } from '@mui/icons-material';
import {
  ActionStyle,
  ActionType,
  DraftLinkIcon,
} from '@prismamedia/one-components';
import { createTypeStrategy, DraftJS, MegadraftIcons } from 'megadraft';
import { Link } from './Link';
import React from 'react';

export const CUSTOM_DRAFT_ACTIONS = [
  {
    type: ActionType.inline,
    label: 'B',
    style: ActionStyle.BOLD,
    icon: MegadraftIcons.BoldIcon,
  },
  {
    type: ActionType.inline,
    label: 'I',
    style: ActionStyle.ITALIC,
    icon: MegadraftIcons.ItalicIcon,
  },
  {
    type: ActionType.entity,
    label: 'Link',
    style: ActionStyle.LINK,
    entity: 'LINK',
    icon: DraftLinkIcon,
  },
  {
    type: ActionType.inline,
    label: 'U',
    style: 'UNDERLINE',
    icon: () => <FormatUnderlined />,
  },
];

export const CUSTOM_DRAFT_DECORATORS = new DraftJS.CompositeDecorator([
  {
    strategy: createTypeStrategy('LINK'),
    component: Link,
  },
]);

export const EDITABLE_DRAFT_PLACEHOLDER = 'Saisir un contenu';

export const EDITABLE_DRAFT_STYLE_MAP = {
  BOLD: {
    fontWeight: '800',
  },
};
